import React, {
    FC,
    memo,
    useCallback,
    useState
} from 'react'
import { useDispatch } from 'react-redux'

import { addModal } from 'features/modals/modalSlice'

import { BoothConfigModal, BoothConfigListItem } from '../types'
import SortableListContainer from './SortableListContainer'

export interface SortableListProps {
    onDelete: (id: number) => void
    items: any[]
    ModalComponent: FC<BoothConfigModal>
    ItemComponent: FC<BoothConfigListItem>
    title: string
    disableAddWithMessage?: string
    titleAdd: string
    titleEdit: string
    addButton: string
    showTranslatedIndicator?: boolean
}

const SortableList = (props: SortableListProps) => {
    const {
        onDelete,
        items = [],
        ModalComponent,
        ItemComponent,
        disableAddWithMessage,
        title,
        addButton,
        titleAdd,
        titleEdit,
        showTranslatedIndicator,
    }: SortableListProps = props

    const dispatch = useDispatch()
    const [deletedItems, setDeletedItems] = useState([])
    const filteredItems = items.filter(({ id }) => !deletedItems.includes(id))

    const buttonAddClickHandler = useCallback(() => {
        dispatch(
            addModal({
                Component: ({ close }: { close: () => void }) => (
                    <ModalComponent close={close} />
                ),
                header: titleAdd || '',
                size: 'lg',
            })
        )
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dispatch, titleAdd])

    const buttonEditClickHandler = useCallback(
        (id) => {
            const data = items.filter((item) => item.id === id)[0] || null
            const modalProps = { data, ...props }

            dispatch(
                addModal({
                    Component: ({ close }: { close: () => void }) => (
                        <ModalComponent close={close} {...modalProps} />
                    ),
                    header: titleEdit || '',
                    size: 'lg',
                })
            )
        },
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [dispatch, items, props, titleEdit]
    )

    const buttonDeleteClickHandler = (id) => {
        onDelete(id)
        setDeletedItems([...deletedItems, id])
    }

    return (
        <SortableListContainer
            title={title}
            onButtonAddClick={buttonAddClickHandler}
            addButton={addButton}
            disableAddWithMessage={disableAddWithMessage}
        >
            {filteredItems.map((item: any) => (
                <ItemComponent
                    key={item.id}
                    onButtonEditClick={buttonEditClickHandler}
                    onButtonDeleteClick={buttonDeleteClickHandler}
                    data={item as any}
                    showTranslatedIndicator={showTranslatedIndicator}
                />
            ))}
        </SortableListContainer>
    )
}

export default memo(SortableList)
